import { useEffect, useState } from "react";
import styled from 'styled-components';
import SpeechComponent from "./Speech";
import { SearchIcon, ClearIcon } from "../../Common/Icons";
import "./Field.scss";

const Input = styled.div`
  color: ${(props) => props.inputColor};
  border: ${(props) => props.inputBorder};
  font-size: ${(props) => props.inputFontSize};
  height: ${(props) => props.inputHeight};
  max-width: ${(props) => props.searchWidth};
  
  input {
    color: ${(props) => props.inputColor};
  }
`;

const Button = styled.button`
  order: 9;
  border: none;
  cursor: pointer;
  background-color: ${(props) => props.buttonBackgroundColor};
  width: ${(props) => props.buttonWidth};
  max-width: ${(props) => props.buttonWidth}; 
  height: 100%;

  & > svg {
    fill: ${(props) => props.iconColor};
    width: ${(props) => props.iconSize};
    height: ${(props) => props.iconSize};
  }
`;

function SearchFieldComponent({ onChange, onSubmit, onClose, options }) {
  const initialOptions = {...options};
  const keySearch = initialOptions.keySearch || 'pesquisa';

  const config = Object.entries(options)
    // ignore undefined
    .filter(([option, value]) => value !== undefined)
    // merge options with default
    .reduce(
      (obj, [option, value]) => {
        obj[option] = value;
        return obj;
      },
      {
        input_placeholder: `Pesquisa...`,
        submit_label: <SearchIcon />,
        clear_label: <ClearIcon />,
        use_voice: false,
      }
    );

  const [input, setInput] = useState("");

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const pesquisa = urlParams.get(keySearch);

    setInput(pesquisa);
    onChange(pesquisa); 
  }, [])

  const handleInput = (event) => {
    const inputSearch = event.target.value;
    setInput(inputSearch);
  };

  useEffect(() => {
    onChange(input);
    const url = new URL(window.location.href);
    if (input) {
      url.searchParams.set(keySearch, input);
    } else {
      url.searchParams.delete(keySearch);
      onClose();
    }
    window.history.replaceState(null, null, url);
  }, [input]);

  const clearInput = (event) => {
    console.log(event);
    setInput("");
    onClose();
  };

  return (
    <Input
      className={`bn-search__field ${input && input.length ? `hasinput` : ``}`}
      {...initialOptions.customOptions}
    >
      <input
        className="bn-search__input"
        onChange={handleInput}
        value={input || ""}
        type="text"
        placeholder={config.input_placeholder}
      />
      <button
        type="button"
        className="bn-search__clear"
        onClick={clearInput}
        style={{ visibility: input && input.length ? `visible` : `hidden` }}
      >
        {config.clear_label}
      </button>
      {config.use_voice ? (
        <SpeechComponent
          onText={setInput}
          onFinish={(e) => onSubmit(e, true)}
          options={options}
        />
      ) : (
        ``
      )}
      <Button
        type="button"
        className="bn-search__submit"
        onClick={() => onSubmit(input)}
        {...initialOptions.customOptions}
      >
        {config.submit_label}
      </Button>
    </Input>
  );
}

export default SearchFieldComponent;
